/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
var Model = Backbone.Model.extend({
  defaults: {
    value: [],
    select: [],
    count: 0,
    aggregate: []
  }
});
export default Model;

